import { FontSizes } from '@uifabric/styling';
import {
    SuggestionsHeaderFooterInfoStyleProps,
    SuggestionsHeaderFooterInfoStyles,
} from './SuggestionsHeaderFooterInfo.types';

export const getStyles = (
    props: SuggestionsHeaderFooterInfoStyleProps
): SuggestionsHeaderFooterInfoStyles => {
    const { theme } = props;
    const { palette } = theme;

    return {
        container: [
            {
                height: '48px',
                width: '100%',
                overflow: 'hidden',
                display: 'table',
            },
        ],
        textContainer: [
            {
                fontSize: FontSizes.small,
                width: 'calc(100% - 46px)',
                textAlign: 'left',
                display: 'table-cell',
                verticalAlign: 'middle',
                paddingLeft: '12px',
            },
        ],
        centered: [
            {
                width: '100%',
                textAlign: 'center',
                padding: 0,
            },
        ],
        iconContainer: [
            {
                paddingLeft: '12px',
                paddingTop: '14px',
                width: '32px',
                display: 'table-cell',
                textAlign: 'center',
            },
        ],
        searchIcon: [
            {
                fontSize: FontSizes.xLarge,
                color: palette.themePrimary,
            },
        ],
        useAddressContainer: [
            {
                height: '36px',
            },
        ],
        suggestedContactsText: [
            {
                fontSize: FontSizes.small,
                color: palette.themePrimary,
            },
        ],
        suggestedContactsHeaderBox: [
            {
                height: '30px',
            },
        ],
        headerBorder: [
            {
                borderBottom: '1px solid',
                borderColor: palette.neutralLight,
            },
        ],
        footerBorder: [
            {
                borderTop: '1px solid',
                borderColor: palette.neutralLight,
            },
        ],
        feedbackContainer: [
            {
                display: 'block',
                width: '100%',
                padding: '5px 5px 5px 12px',
                color: palette.themePrimary,
            },
        ],
        linkedInIcon: [
            {
                color: '#0077b5', // Hard coded color because this is a brand icon
                fontSize: '32px',
            },
        ],
        linkedInBindContainer: [
            {
                height: '48px',
                paddingLeft: '12px',
                position: 'relative',
                boxSizing: 'border-box',
            },
            [
                {
                    selectors: {
                        ':active': {
                            backgroundColor: palette.neutralLight,
                        },
                    },
                },
            ],
        ],
        verticalCenter: [
            {
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
            },
        ],
        linkedInBindText: [
            {
                left: '56px',
            },
        ],
        cancelIcon: [
            {
                fontSize: FontSizes.small,
                color: palette.neutralPrimary,
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
            },
        ],
        linkedinBindingDismiss: [
            {
                position: 'absolute',
                right: 0,
                width: 'calc(15% - 12px)',
                height: '48px',
            },
            [
                {
                    selectors: {
                        ':hover': {
                            backgroundColor: palette.neutralLight,
                        },
                    },
                },
            ],
        ],
    };
};
